import React, {useMemo, useEffect, useRef, useState } from "react";
import axios from "axios";
import Source from "../../Source";
import Swal from "sweetalert2";
import Profile from "../../assets/icon/profile.png";
import IdNational from "../../assets/icon/national_id.png";
import { useSelector, useDispatch } from "react-redux";
import { addCustomerToCache, getCustomers } from "../Redux/customerSlice";
import "./style.css";
import { FormattedMessage } from "react-intl";
import moment from "moment-jalaali";

const formatNumber = (number) => {
  return number?.toLocaleString(); // Formats number with thousand separators
};
export default function ShowProfit({
  close,
  addAccountModal,
  record,
  setRecord,
  accounts,
  inputRef,
  ShowBill,
}) {
  const date = (d) => {
      const date = new Date(d);
      let formattedDate = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? "pm" : "am";
      let aa = ampm;
      const formattedHours = hours % 12 || 12;
      const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      if (localStorage.getItem("date") === "Persian") {
        moment.locale("fa"); // تنظیم لوکال به فارسی
        aa = hours >= 12 ? "ب.ظ" : "ق.ظ";
        formattedDate = moment(d).format("jYYYY-jMM-jDD");
      } else {
        moment.locale("en"); // تنظیم لوکال به انگلیسی
      }
  
      return `${formattedDate} ${formattedHours}:${formattedMinutes} ${aa}`;
    };
  return (
    <div
      className={`container rounded-5 popup customer ${
        addAccountModal ? "show" : ""
      }`}
      style={{
        maxWidth: "70%",
        overflowX: "auto",
        overflowY: "auto",
        height: "80vh",
        backgroundColor: "#f8f9fa",
        padding: "10px",
        zIndex: "10000",
      }}
    >
      <div
        class="card card-body m-auto"
        style={{ borderTop: "5px solid #4a5cf2" }}
      >
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn-close p-3 m-1 mt-0 hover_btn"
            onClick={close}
            aria-label="Close"
          ></button>
        </div>
        <h1 class="text-center rounded m-0 mb-2 p-4 text-light fw-bold bg-info">
          <FormattedMessage id="Tracking of profite" />
        </h1>
    <table className="table table-light table-striped">
  <thead>
    <tr>
      <th scope="col"><FormattedMessage id="Name" /></th>
      <th scope="col"><FormattedMessage id="Profit" /></th>
      <th scope="col"><FormattedMessage id="S Amount" /></th>
      <th scope="col"><FormattedMessage id="T Amount" /></th>
      <th scope="col"><FormattedMessage id="Date" /></th>
    </tr>
  </thead>
  <tbody className="table-group-divider">
    {record.map((row, idx) => (
      <tr key={idx}>
        <td>{row.name}</td>
        <td><span dir="ltr">{formatNumber(row.profit)}</span></td>
        <td>{formatNumber(row.s_amount)}</td>
        <td>{formatNumber(row.t_amount)}</td>
        <td>{date(row.created_at)}</td>
      </tr>
    ))}
  </tbody>
</table>

      </div>
    </div>
  );
}
